import { useClose } from '@headlessui/react';
import { Ui } from '@silvertours/front-shared';
import { RegionalSettings } from './RegionalSettings';
import { TriggerButton } from './RegionalSettings.styles';
import { useRegionalSettingsTrigger } from './RegionalSettingsTrigger';

/**
 * Renders the settings form inside the flyout and closes it once a currency is
 * picked. `useClose` must be called from within the Popover subtree.
 */
const FlyoutContent = () => {
  const close = useClose();
  return <RegionalSettings onCurrencyChange={() => close()} />;
};

/**
 * Desktop entry point for the regional settings. Shows the active market as a
 * flag plus the selected currency code and opens the settings form in a flyout
 * bubble.
 */
const RegionalSettingsFlyout = () => {
  const { ariaLabel, flag } = useRegionalSettingsTrigger();

  return (
    <Ui.Popover
      button={{
        as: TriggerButton,
        'aria-label': ariaLabel,
        children: flag,
      }}
    >
      <Ui.PopoverPanel>
        <Ui.PanelContentWrapper
          width="14rem"
          widthMd="21.875rem"
          padding="1.5rem 0 0 0"
        >
          <FlyoutContent />
        </Ui.PanelContentWrapper>
      </Ui.PopoverPanel>
    </Ui.Popover>
  );
};

export { RegionalSettingsFlyout };
